// Theme configuration for the gzt.com platform
// Modern and minimal, but not flat
// Clean typography, colorful components
// Use of gradient buttons, shadowed cards, smooth spacing
// Theme: Light Mode (no dark theme)

export const theme = {
  colors: {
    primary: '#4E7CFF', // Vibrant blue as primary color
    secondary: '#FF6B6B', // Coral red as secondary color
    accent: '#FFD166', // Yellow accent
    success: '#06D6A0', // Teal for success states
    warning: '#FFD166', // Yellow for warnings
    error: '#EF476F', // Pink for errors
    background: '#FFFFFF', // White background
    cardBg: '#F9FAFC', // Light gray for cards
    text: {
      primary: '#1A1A2E', // Dark blue for primary text
      secondary: '#4A4A68', // Medium gray for secondary text
      tertiary: '#9191A4', // Light gray for tertiary text
      inverse: '#FFFFFF', // White text for dark backgrounds
    },
    border: '#E6E8F0', // Light gray for borders
    divider: '#EAEDF3', // Very light gray for dividers
  },

  gradients: {
    primary: 'linear-gradient(90deg, #4E7CFF 0%, #6A8FFF 100%)',
    secondary: 'linear-gradient(90deg, #FF6B6B 0%, #FF8E8E 100%)',
    accent: 'linear-gradient(90deg, #FFD166 0%, #FFE066 100%)',
  },

  typography: {
    fontFamily: "'Poppins', sans-serif",
    fontSizes: {
      xs: '0.75rem', // 12px
      sm: '0.875rem', // 14px
      md: '1rem',     // 16px
      lg: '1.125rem', // 18px
      xl: '1.25rem',  // 20px
      '2xl': '1.5rem', // 24px
      '3xl': '1.875rem', // 30px
      '4xl': '2.25rem',  // 36px
    },
    fontWeights: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeights: {
      tight: 1.2,
      normal: 1.5,
      loose: 1.8,
    },
  },

  spacing: {
    xs: '0.25rem', // 4px
    sm: '0.5rem',  // 8px
    md: '1rem',    // 16px
    lg: '1.5rem',  // 24px
    xl: '2rem',    // 32px
    '2xl': '3rem', // 48px
    '3xl': '4rem', // 64px
  },

  borderRadius: {
    sm: '0.25rem', // 4px
    md: '0.5rem',  // 8px
    lg: '1rem',    // 16px
    full: '9999px', // Fully rounded
  },

  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.1)',
    md: '0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.08)',
    lg: '0 10px 15px rgba(0, 0, 0, 0.05), 0 4px 6px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px rgba(0, 0, 0, 0.04), 0 10px 10px rgba(0, 0, 0, 0.04)',
  },

  transitions: {
    fast: '0.15s ease-in-out',
    normal: '0.25s ease-in-out',
    slow: '0.4s ease-in-out',
  },

  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },

  zIndices: {
    base: 0,
    dropdown: 1000,
    sticky: 1100,
    fixed: 1200,
    modal: 1300,
    popover: 1400,
    tooltip: 1500,
  },
};
